import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import getScreenNameKorean from '../pages/user/util/getScreenNameKorean';

const GtmPageTracker = () => {
    const location = useLocation();

    // 개발테스트시 isProduction/gtmEnabled = 두 항목 true 로 적용하여 테스트할것!
    // const isProduction = true;
    // const gtmEnabled = true;
    const isProduction = process.env.NODE_ENV === 'production';
    const gtmEnabled = process.env.REACT_APP_GTM_ENABLED === 'true';

    useEffect(() => {
        if (!isProduction || !gtmEnabled) return;

        if (!window.dataLayer) {
            window.dataLayer = [];
        }

        const loginUser = JSON.parse(sessionStorage.getItem('loginUser') || 'null');
        const usrInfoId = loginUser?.usrInfoId || null;
        const isLoggedIn = !!usrInfoId;
        const analyticsUserId = isLoggedIn ? `AFTCR${usrInfoId}DGTP` : undefined;

        const screenNameKr = getScreenNameKorean(location.pathname);

        window.dataLayer.push({
            event: 'page_view',
            page_path: location.pathname,
            page_location: location.pathname + location.search,
            page_title: `${screenNameKr} | CMC careplus`,
            user_id: analyticsUserId,
            // is_logged_in: isLoggedIn
        });

    }, [location.pathname, location.search, isProduction, gtmEnabled]);

    return null;
};

export default GtmPageTracker;
